import Crud from "../Crud";
import MUIBlueColor from "@mui/material/colors/blue";

export default class Provider extends Crud {
    static getDisplayName(provider) {
        if (!provider) {
            return null;
        }

        const parts = [];

        if (provider.firstName !== null) {
            parts.push(provider.firstName.trim());
        }

        if (provider.lastName !== null) {
            parts.push(provider.lastName.trim());
        }

        return parts.join(' ');
    }

    /**
     * Gets the full display name for the provider including name, credential, location, and npi
     * @param {*} provider
     * @returns
     */
    static getDetailedDisplayName(provider) {
        if (!provider) {
            return null;
        }

        const name = [provider.firstName, provider.lastName]
            .filter(Boolean)
            .join(' ');

        const credential = provider.credential?.trim();
        const nameWithCredential = credential ? `${name}, ${credential}` : name;

        const location = [provider.city, provider.state]
            .filter(Boolean)
            .join(', ');

        const parts = [
            nameWithCredential,
            location || null,
            provider.npi || null
        ].filter(Boolean); // remove null or empty parts

        return parts.join(' - ');
    }

    static match(provider, query) {
        return (
            (
                provider.firstName !== null &&
                provider.firstName.toLowerCase().includes(query)
            ) ||
            (
                provider.firstName !== null &&
                provider.lastName !== null &&
                (
                    (provider.firstName.toLowerCase() + ' ' + provider.lastName.toLowerCase()).includes(query) ||
                    (provider.lastName.toLowerCase() + ' ' + provider.firstName.toLowerCase()).includes(query) ||
                    (provider.lastName.toLowerCase() + ', ' + provider.firstName.toLowerCase()).includes(query) ||
                    (provider.lastName.toLowerCase() + ',' + provider.firstName.toLowerCase()).includes(query)
                )
            ) ||
            (
                provider.lastName !== null &&
                provider.lastName.toLowerCase().includes(query)
            ) ||
            (
                provider.npi !== null &&
                provider.npi.toLowerCase().includes(query)
            )
        );
    }

    static getAddress(provider) {
        const parts = [];

        if (provider.address1 !== null) {
            parts.push(provider.address1.trim());
        }
        if (provider.address2 !== null) {
            parts.push(provider.address2.trim());
        }
        return parts.join(', ');
    }

    static sort(providers) {
        return providers.sort((a, b) => a.code.localeCompare(b.code));
    }

    static getBaseColor() {
        return MUIBlueColor;
    }

    static getIconName() {
        return "Medical";
    }
}
